import Sidemenu from '../components/base/sidemenu';
import Device from '../components/device/device';

export default function DevicePage() {
    return (
        <div className='flex'>
            <Sidemenu />
            <Device />
        </div>
    );
}
